import { ReconciliationTransaction } from '@modules-deprecated/bankReconciliation/types'
import { prefixAmount, prefixGrossAmount } from '@modules-deprecated/bankReconciliation/utils'

import { PayableSubject } from '../../paymentReconciliationModal/types'
import { getSubjectReconciliationDifference } from './getSubjectReconciliationDifference'
import { getTypeFromPayableSubject } from './getTypeFromPayableSubject'

export const reconciliationSuggestHasDifference = (
  reconciliationTransaction?: ReconciliationTransaction,
  subject?: PayableSubject,
  isCreditNoteSelected = false,
) => {
  const reconciliationAmount = prefixAmount(reconciliationTransaction)
  const invoiceAmount = prefixGrossAmount(subject)
  const difference = getSubjectReconciliationDifference({
    isCreditNote: isCreditNoteSelected,
    subjectsAmount: invoiceAmount,
    reconciliationAmount,
    subjectType: getTypeFromPayableSubject(subject),
  })

  return difference?.differenceAmount !== 0
}
